module.exports = __webpack_public_path__ + "img/NOVA_Login.8d10eb13.png";